<template>
  <div class="public-layout d-flex flex-column min-vh-100">
    <header class="border-bottom bg-white">
      <div class="container py-3">
        <div class="header-wrap d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3">
          <RouterLink to="/" class="d-flex align-items-center text-decoration-none gap-2">
            <img src="/assets/img/logo.png" alt="FinPlan" class="logo" />
            <span class="fs-5 fw-bold text-dark">FinPlan</span>
          </RouterLink>

          <nav class="nav-wrap d-flex flex-wrap gap-2 gap-md-3 align-items-center">
            <RouterLink to="/" class="nav-link-custom">Главная</RouterLink>
            <RouterLink to="/privacy" class="nav-link-custom">Privacy</RouterLink>
            <RouterLink to="/terms" class="nav-link-custom">Terms</RouterLink>

            <RouterLink to="/auth" class="btn btn-primary btn-sm">
              Открыть приложение
            </RouterLink>
          </nav>
        </div>
      </div>
    </header>

    <main class="flex-grow-1 bg-light">
      <RouterView />
    </main>

    <footer class="border-top bg-white mt-auto">
      <div class="container py-4 d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-2">
        <div class="text-muted small">
          © {{ new Date().getFullYear() }} FinPlan
        </div>

        <div class="d-flex flex-wrap gap-3 small">
          <RouterLink to="/privacy" class="text-decoration-none">Privacy Policy</RouterLink>
          <RouterLink to="/terms" class="text-decoration-none">Terms of Service</RouterLink>
        </div>
      </div>
    </footer>
  </div>
</template>

<script setup>
import { RouterLink, RouterView } from 'vue-router'
</script>

<style scoped>
.logo {
  width: 32px;
  height: 32px;
  object-fit: contain;
}

.nav-link-custom {
  text-decoration: none;
  color: #212529;
  padding: 0.25rem 0;
}

.nav-link-custom:hover {
  color: #0d6efd;
}

@media (max-width: 767.98px) {
  .nav-wrap {
    width: 100%;
  }

  .nav-wrap .btn {
    width: 100%;
  }
}
</style>